module.exports = __webpack_public_path__ + "static/media/image2.8785dea7.jpg";